'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.ComponentLifecycleService = void 0;
var tslib_1 = require('tslib');
var typed_redux_saga_1 = require('typed-redux-saga');
var decorators_1 = require('../decorators');
var emptyFlow_1 = require('../utils/emptyFlow');
var isNodeEnv_1 = require('../utils/isNodeEnv');
var Service_1 = require('./Service');
var DISPOSE_SIGNAL = 'DISPOSE_SIGNAL';
function isDisposeSignal(loadId) {
    return function disposePattern(_a) {
        var type = _a.type,
            payload = _a.payload;
        return type === DISPOSE_SIGNAL && payload === loadId;
    };
}
var ComponentLifecycleService = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ComponentLifecycleService, _super);
    function ComponentLifecycleService() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.EXECUTION_MAP = {};
        return _this;
    }
    ComponentLifecycleService.prototype.toString = function () {
        return 'ComponentLifecycleService';
    };
    ComponentLifecycleService.prototype.load = function (options) {
        var operationId,
            next,
            loadId,
            saga,
            args,
            operationId_1,
            options_1,
            _a,
            onLoad,
            _b,
            onDispose,
            loadOperation,
            loadTask;
        return (0, tslib_1.__generator)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    operationId = options.operationId;
                    if (!(!this.EXECUTION_MAP[operationId] && !(0, isNodeEnv_1.isNodeEnv)())) return [3 /*break*/, 2];
                    return [
                        5 /*yield**/,
                        (0, tslib_1.__values)(
                            (0, typed_redux_saga_1.call)(this._operationsService.registerConsumer, this, operationId)
                        ),
                    ];
                case 1:
                    _c.sent();
                    _c.label = 2;
                case 2:
                    next = this.EXECUTION_MAP[operationId];
                    this.EXECUTION_MAP[operationId] = options;
                    if (next) {
                        return [2 /*return*/];
                    }
                    _c.label = 3;
                case 3:
                    if (!(this.EXECUTION_MAP[operationId] && next !== this.EXECUTION_MAP[operationId]))
                        return [3 /*break*/, 8];
                    next = this.EXECUTION_MAP[operationId];
                    if (!next) return [3 /*break*/, 7];
                    (loadId = next.loadId),
                        (saga = next.saga),
                        (args = next.args),
                        (operationId_1 = next.operationId),
                        (options_1 = next.options);
                    (_a = saga.onLoad),
                        (onLoad = _a === void 0 ? emptyFlow_1.emptyFlow : _a),
                        (_b = saga.onDispose),
                        (onDispose = _b === void 0 ? emptyFlow_1.emptyFlow : _b);
                    loadOperation = this._operationsService.createOperation({
                        operationArgs: [
                            operationId_1,
                            onLoad,
                            options_1 === null || options_1 === void 0 ? void 0 : options_1.updateStrategy,
                        ],
                    });
                    return [
                        5 /*yield**/,
                        (0, tslib_1.__values)(
                            typed_redux_saga_1.fork.apply(
                                void 0,
                                (0, tslib_1.__spreadArray)([loadOperation.run], (0, tslib_1.__read)(args), false)
                            )
                        ),
                    ];
                case 4:
                    loadTask = _c.sent();
                    return [5 /*yield**/, (0, tslib_1.__values)((0, typed_redux_saga_1.take)(isDisposeSignal(loadId)))];
                case 5:
                    _c.sent();
                    loadTask.cancel();
                    return [
                        5 /*yield**/,
                        (0, tslib_1.__values)(
                            typed_redux_saga_1.call.apply(
                                void 0,
                                (0, tslib_1.__spreadArray)([onDispose], (0, tslib_1.__read)(args), false)
                            )
                        ),
                    ];
                case 6:
                    _c.sent();
                    _c.label = 7;
                case 7:
                    return [3 /*break*/, 3];
                case 8:
                    this.EXECUTION_MAP[operationId] = undefined;
                    return [2 /*return*/];
            }
        });
    };
    ComponentLifecycleService.prototype.dispose = function (id) {
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [
                        5 /*yield**/,
                        (0, tslib_1.__values)((0, typed_redux_saga_1.put)({ type: DISPOSE_SIGNAL, payload: id })),
                    ];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    };
    ComponentLifecycleService.prototype.cleanup = function (_a) {
        var operationId = _a.operationId;
        return (0, tslib_1.__generator)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    this.EXECUTION_MAP[operationId] = undefined;
                    return [
                        5 /*yield**/,
                        (0, tslib_1.__values)(
                            (0, typed_redux_saga_1.call)(this._operationsService.unregisterConsumer, this, operationId)
                        ),
                    ];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    };
    (0, tslib_1.__decorate)(
        [
            (0, decorators_1.daemon)(decorators_1.DaemonMode.Every),
            (0, tslib_1.__metadata)('design:type', Function),
            (0, tslib_1.__metadata)('design:paramtypes', [Object]),
            (0, tslib_1.__metadata)('design:returntype', void 0),
        ],
        ComponentLifecycleService.prototype,
        'load',
        null
    );
    (0, tslib_1.__decorate)(
        [
            (0, decorators_1.daemon)(decorators_1.DaemonMode.Every),
            (0, tslib_1.__metadata)('design:type', Function),
            (0, tslib_1.__metadata)('design:paramtypes', [String]),
            (0, tslib_1.__metadata)('design:returntype', void 0),
        ],
        ComponentLifecycleService.prototype,
        'dispose',
        null
    );
    (0, tslib_1.__decorate)(
        [
            (0, decorators_1.daemon)(decorators_1.DaemonMode.Every),
            (0, tslib_1.__metadata)('design:type', Function),
            (0, tslib_1.__metadata)('design:paramtypes', [Object]),
            (0, tslib_1.__metadata)('design:returntype', void 0),
        ],
        ComponentLifecycleService.prototype,
        'cleanup',
        null
    );
    return ComponentLifecycleService;
})(Service_1.Service);
exports.ComponentLifecycleService = ComponentLifecycleService;
